import { render, staticRenderFns } from "./ViqWelcome.vue?vue&type=template&id=3eb860e0&scoped=true"
import script from "./ViqWelcome.vue?vue&type=script&lang=js"
export * from "./ViqWelcome.vue?vue&type=script&lang=js"
import style0 from "./ViqWelcome.vue?vue&type=style&index=0&id=3eb860e0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb860e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eb860e0')) {
      api.createRecord('3eb860e0', component.options)
    } else {
      api.reload('3eb860e0', component.options)
    }
    module.hot.accept("./ViqWelcome.vue?vue&type=template&id=3eb860e0&scoped=true", function () {
      api.rerender('3eb860e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqWelcome.vue"
export default component.exports